"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.light = void 0;
exports.light = {
    "background": {
        "default": "#ffffff",
        "contrast": "#f5f6fa",
        "hover": "rgba(0, 0, 0, 0.06)",
        "selected": "rgba(0, 0, 0, 0.1)",
        "overlay": "#ffffff",
        "primary": "#efecfb",
        "critical": "#faece8",
        "warning": "#fdf5eb",
        "success": "#ebf6ef",
        "highlighted": {
            "primary": "#633fd3",
            "success": "#459B64",
            "warning": "#E6A03B",
            "critical": "#BC4D29"
        },
        "level0": "#f5f6fa",
        "level1": "#ffffff"
    },
    "border": {
        "default": "#e8e8e8",
        "form": "#707070",
        "formCritical": "#BC4D29",
        "contrast": "#d7dbeb",
        "selected": "#000000",
        "primary": "#d1c8f3",
        "critical": "#f2cfc4",
        "warning": "#f9e1c3",
        "success": "#cde9d7",
        "accessibleBorder": "#707070"
    },
    "content": {
        "default": "#000000",
        "subdued": "#707070",
        "disabled": "#6B6B6B",
        "placeholder": "#707070",
        "primary": "#633fd3",
        "success": "#459B64",
        "warning": "#E6A03B",
        "critical": "#BC4D29",
        "accent": {
            "success": "#3E7957",
            "warning": "#A45E0A",
            "critical": "#B64C2F"
        },
        "above": {
            "primary": "#ffffff",
            "secondary": "#000000",
            "text": "#000000",
            "contrast": "#000000",
            "critical": "#BC4D29"
        }
    },
    "interactive": {
        "primary": {
            "default": "#000000",
            "hover": "#0d0d0d",
            "pressed": "#242424"
        },
        "secondary": {
            "default": "#ebebeb",
            "hover": "#dedede",
            "pressed": "#c7c7c7"
        },
        "contrast": {
            "default": "#ffffff",
            "hover": "rgba(255, 255, 255, 0.9)",
            "pressed": "rgba(255, 255, 255, 0.75)"
        },
        "text": {
            "default": "rgba(0, 0, 0, 0)",
            "hover": "rgba(0, 0, 0, 0.1)",
            "pressed": "rgba(0, 0, 0, 0.12)"
        },
        "critical": {
            "default": "#faece8",
            "hover": "#f6dcd4",
            "pressed": "#eebeb1"
        },
        "disabled": "#ebeef5"
    },
    "benefits": {
        "mealVoucher": {
            "content": {
                "default": "#EF1090",
                "selected": "#a70b65"
            },
            "background": {
                "default": "#fde7f4",
                "selected": "#f7a4d5"
            }
        },
        "gift": {
            "content": {
                "default": "#F35728",
                "selected": "#bc330a"
            },
            "background": {
                "default": "#feeeea",
                "selected": "#fbb5a4"
            }
        },
        "mobility": {
            "content": {
                "default": "#48A202",
                "selected": "#327101"
            },
            "background": {
                "default": "#ecffdd",
                "selected": "#c4ff96"
            }
        },
        "personalWallet": {
            "content": {
                "default": "#0392E5",
                "selected": "#0266a0"
            },
            "background": {
                "default": "#e4f5ff",
                "selected": "#9cdaff"
            }
        },
        "cashback": {
            "content": {
                "default": "#CA7628",
                "selected": "#8d531c"
            },
            "background": {
                "default": "#fbf1e9",
                "selected": "#f0caac"
            }
        }
    },
    "social": {
        "pot": {
            "content": {
                "default": "#0392E5",
                "selected": "#0266a0"
            },
            "background": {
                "default": "#e4f5ff",
                "selected": "#9cdaff"
            }
        },
        "activity": {
            "content": {
                "default": "#48A202",
                "selected": "#327101"
            },
            "background": {
                "default": "#ecffdd",
                "selected": "#c4ff96"
            }
        },
        "pulse": {
            "content": {
                "default": "#1CA07B",
                "selected": "#147056"
            },
            "background": {
                "default": "#e4faf4",
                "selected": "#a8efdb"
            }
        },
        "praise": {
            "default": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#a70b65"
                },
                "background": {
                    "default": "#fde7f4",
                    "selected": "#f7a4d5"
                }
            },
            "birthday": {
                "content": {
                    "default": "#633fd3",
                    "selected": "#41249c"
                },
                "background": {
                    "default": "#efecfb",
                    "selected": "#bcb0ee"
                }
            },
            "celebration": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#a70b65"
                },
                "background": {
                    "default": "#fde7f4",
                    "selected": "#f7a4d5"
                }
            },
            "congrats": {
                "content": {
                    "default": "#48A202",
                    "selected": "#327101"
                },
                "background": {
                    "default": "#ecffdd",
                    "selected": "#c4ff96"
                }
            },
            "egoboost": {
                "content": {
                    "default": "#0392E5",
                    "selected": "#0266a0"
                },
                "background": {
                    "default": "#e4f5ff",
                    "selected": "#9cdaff"
                }
            },
            "onboarding": {
                "content": {
                    "default": "#CA7628",
                    "selected": "#8d531c"
                },
                "background": {
                    "default": "#fbf1e9",
                    "selected": "#f0caac"
                }
            },
            "proanniversary": {
                "content": {
                    "default": "#F35728",
                    "selected": "#bc330a"
                },
                "background": {
                    "default": "#feeeea",
                    "selected": "#fbb5a4"
                }
            },
            "procelebration": {
                "content": {
                    "default": "#F35728",
                    "selected": "#bc330a"
                },
                "background": {
                    "default": "#feeeea",
                    "selected": "#fbb5a4"
                }
            },
            "thanks": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#a70b65"
                },
                "background": {
                    "default": "#fde7f4",
                    "selected": "#f7a4d5"
                }
            }
        },
        "article": {
            "content": {
                "default": "#CA7628",
                "selected": "#8d531c"
            },
            "background": {
                "default": "#fbf1e9",
                "selected": "#f0caac"
            }
        }
    },
    "cards": {
        "black": {
            "primary": "#111111",
            "accent": "#272727"
        },
        "grey": {
            "primary": "#585858",
            "accent": "#e5e5e5"
        },
        "midnightBlue": {
            "primary": "#00084b",
            "accent": "#e5e8ff"
        },
        "gold": {
            "primary": "#c8ba95",
            "accent": "#f3f0e7"
        },
        "pink": {
            "primary": "#edc2bd",
            "accent": "#f7e5e3"
        }
    },
    "title": {
        "red": "#FF2055",
        "blue": "#336DFF",
        "magenta": "#E40AAF",
        "indigo": "#A51CF1"
    },
    "travel": {
        "hotel": {
            "purpleBase": "#631191",
            "purpleLight": "#C060F5",
            "pinkBase": "#FFA6BB",
            "pinkLight": "#FFD2DD"
        },
        "rental": {
            "redBase": "#991333",
            "redLight": "#FF6388",
            "orangeBase": "#FFD1B3",
            "orangeLight": "#FFE8D9"
        },
        "train": {
            "greenBase": "#008C6B",
            "greenLight": "#4CF0C9",
            "limeBase": "#DFF6AF",
            "limeLight": "#EFFAD7"
        },
        "plane": {
            "blueBase": "#1F4199",
            "blueLight": "#6FCFFE",
            "mintBase": "#99F7E0",
            "mintLight": "#CCFBF0"
        }
    }
};
